import * as FPT from './fpt'

/**
 * Loads bodymovin and hearts animation json
 */
export function loadBodyMovin() {
	return Promise.all([
		import(/* webpackChunkName: 'bodymovin' */ 'bodymovin'),
		import(/* webpackChunkName: 'hearts' */ '../vendor/hearts.json'),
	])
	.catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'bodymovin',
			error
		});
	})
}

/**
 * Load Progressive Onboarding component
 */
export function loadProgressiveOnboarding() {
	return Promise.all([
		import(/* webpackChunkName: 'Progressiveonboarding' */ 'portableonboarding/build/fullBundle')
	]).catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'progressive',
			error
		});
	})
}


export function loadPortableP2P() {
	return Promise.all([
		import(/* webpackChunkName: 'PortableP2P' */ 'portable-p2p/dist/buy')
	]).catch((error) => {
		FPT.trackError({
			message: 'LAZY_LOAD_FAILED',
			code: 'portablep2p',
			error
		});
	})
}



// WEBPACK FOOTER //
// ./utility/lazyLoader.js